import React from "react";
import "./side.css";

export default function Side() {
    return (
        <div className="side">
            <div className="ad">
                <iframe
                    title="ad"
                    src="https://ads-partners.coupang.com/widgets.html?id=574490&template=carousel&trackingCode=AF7105622&subId=&width=300&height=600"
                    width="300"
                    height="600"
                    frameBorder="0"
                    scrolling="no"
                    referrerPolicy="unsafe-url"
                ></iframe>
            </div>
        </div>
    );
}
